import { useEffect, useState } from 'react';
import {
  formatPdfDownloadCooldown,
  getPdfDownloadCooldownRemaining,
  PDF_DOWNLOAD_COOLDOWN_EVENT,
} from '../helpers/pdfDownloadCooldown';

export default function usePdfDownloadCooldown() {
  const [remaining, setRemaining] = useState<number>(
    getPdfDownloadCooldownRemaining()
  );

  useEffect(() => {
    const sync = () => setRemaining(getPdfDownloadCooldownRemaining());

    // `storage` keeps other open tabs in sync; the custom event covers this tab.
    window.addEventListener('storage', sync);
    window.addEventListener(PDF_DOWNLOAD_COOLDOWN_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(PDF_DOWNLOAD_COOLDOWN_EVENT, sync);
    };
  }, []);

  const isCoolingDown = remaining > 0;

  useEffect(() => {
    if (!isCoolingDown) return;
    const timer = setInterval(
      () => setRemaining(getPdfDownloadCooldownRemaining()),
      1000
    );
    return () => clearInterval(timer);
  }, [isCoolingDown]);

  return {
    isCoolingDown,
    remaining,
    remainingLabel: formatPdfDownloadCooldown(remaining),
  };
}
